/**
 * Get All Countries witout flags importer
 * @param {(Countries)=> {}} callback
 * @returns 
 */
const countries_importer = async function(callback = function(){}){
    if(typeof window.all_only_countries !== "undefined"){
        callback(window.all_only_countries);
        return;
    }
    await fetch("https://cdn.jsdelivr.net/gh/Yerikmiller/Countries-States-Cities-JSON@master/all_only_countries.json").then((r)=>{
        return r.json();
    }).then((response)=>{
        window.all_only_countries = response;
        callback(window.all_only_countries);
    })
}

export { countries_importer }